// Supabase client following official React quickstart pattern
// https://supabase.com/docs/guides/getting-started/quickstarts/reactjs
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Use environment variables following official Supabase pattern
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// Validate environment variables
if (!supabaseUrl) {
  throw new Error('Missing VITE_SUPABASE_URL environment variable');
}
if (!supabaseKey) {
  throw new Error('Missing VITE_SUPABASE_ANON_KEY environment variable');
}

// Create Supabase client
export const supabase = createClient<Database>(supabaseUrl, supabaseKey);

// Export URL and key for debugging
export const config = {
  url: supabaseUrl,
  key: supabaseKey.substring(0, 20) + '...',
  projectId: supabaseUrl.split('.')[0].split('//')[1]
};

// Dev-only: expose Supabase client for console diagnostics
if (import.meta.env.DEV && typeof window !== 'undefined') {
  // @ts-expect-error debug helper
  window.supabase = supabase;
}